module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('a', {
    staticClass: "button button-link button-nav pull-left",
    on: {
      "click": function($event) {
        return _vm.tolast()
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-left"
  }), _vm._v("返回\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "margin-bottom": "3rem"
    }
  }, [_c('div', {
    staticClass: "content-block-title"
  }, [_vm._v(_vm._s(_vm.member.customerPlanName) + "成员信息")]), _vm._v(" "), _c('div', {
    staticClass: "list-block"
  }, [_c('ul', {
    staticStyle: {
      "margin-left": "10px",
      "margin-right": "10px"
    }
  }, [_c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("身份")]), _vm._v(" "), (_vm.member.role === 1) ? _c('div', {
    staticClass: "item-title"
  }, [_vm._v("储值联系人")]) : (_vm.member.role === 2) ? _c('div', {
    staticClass: "item-title"
  }, [_vm._v("积分联系人")]) : (_vm.member.role === 3) ? _c('div', {
    staticClass: "item-title"
  }, [_vm._v("管理联系人")]) : (_vm.member.role === 4) ? _c('div', {
    staticClass: "item-title"
  }, [_vm._v("对账联系人")]) : (_vm.member.role === 5) ? _c('div', {
    staticClass: "item-title"
  }, [_vm._v("普通成员")]) : _c('div', {
    staticClass: "item-title"
  }, [_vm._v("未知")])])]), _vm._v(" "), _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('div', {
    staticClass: "item-title"
  }, [_vm._v(_vm._s(_vm.member.customerPlanMemberName))])])]), _vm._v(" "), _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("编号")]), _vm._v(" "), _c('div', {
    staticClass: "item-title"
  }, [_vm._v(_vm._s(_vm.member.customerPlanMemberNo))])])]), _vm._v(" "), _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("大客户计划编号")]), _vm._v(" "), _c('div', {
    staticClass: "item-title"
  }, [_vm._v(_vm._s(_vm.member.customerPlanNo))])])]), _vm._v(" "), _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("单位")]), _vm._v(" "), _c('div', {
    staticClass: "item-title"
  }, [_vm._v(_vm._s(_vm.member.enterpriseName))])])]), _vm._v(" "), _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("电话")]), _vm._v(" "), _c('div', {
    staticClass: "item-title"
  }, [_vm._v(_vm._s(_vm.member.mobile))])])]), _vm._v(" "), _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("是否禁用")]), _vm._v(" "), (_vm.member.availableFlag === 1) ? _c('div', {
    staticClass: "item-title"
  }, [_vm._v("否")]) : _c('div', {
    staticClass: "item-title"
  }, [_vm._v("否")])])]), _vm._v(" "), _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("加入时间")]), _vm._v(" "), (_vm.member.availableFlag === 1) ? _c('div', {
    staticClass: "item-title"
  }, [_vm._v(_vm._s(_vm.member.joinPlanDt))]) : _vm._e()])]), _vm._v(" "), _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("有效截止时间")]), _vm._v(" "), (_vm.member.availableFlag === 1) ? _c('div', {
    staticClass: "item-title"
  }, [_vm._v(_vm._s(_vm.member.overdueDt))]) : _vm._e()])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-987fae74","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/User/MyVipPlan/memberDetails.vue
// module id = 1699
// module chunks = 8